/* ============================================================
   Incognito — activează origini noi în catalogul public al
   calculatorului (Etiopia Guji + Peru Decaf). Rețetele reale
   rămân în Cloudflare Worker. Rulează după ic-calculator.js
   (același scope lexical global pentru script-uri clasice).
   ============================================================ */
(function () {
  if (typeof ORIGINS === 'undefined') return;

  // Etiopia Guji — activă
  ORIGINS.ethiopia = Object.assign(ORIGINS.ethiopia || {}, {
    name: 'Etiopia',
    region: 'Guji · Guji Mesina',
    color: '#F0CC30',
    process: 'natural',
    variety: 'Heirloom',
    altitude: 1950,
    roast: 'light',
    notes: ['Ciocolată neagră', 'Struguri roșii', 'Ananas'],
    density: 'high',
    active: true,
    handle: 'ethiopia-guji'
  });

  // Peru Decaf — Negrisa — activă
  ORIGINS['peru-decaf'] = {
    name: 'Peru Decaf',
    region: 'Chanchamayo · Villa Rica',
    color: '#F9C170',
    process: 'washed',
    variety: 'Typica',
    altitude: 1500,
    roast: 'medium',
    notes: ['Fructe închise', 'Rubarbă dulce', 'Suculent'],
    density: 'standard',
    active: true,
    handle: 'peru-decaf-negrisa'
  };

  // Prețuri live pentru butonul „Cumpără" (CTA secțiunea 05)
  window.IC_PRODUCT_PRICES = window.IC_PRODUCT_PRICES || {};
  [['ethiopia', 'ethiopia-guji'], ['peru-decaf', 'peru-decaf-negrisa']].forEach(function (p) {
    var key = p[0], handle = p[1];
    if (!window.IC_PRODUCT_PRICES[key]) {
      window.IC_PRODUCT_PRICES[key] = { handle: handle, priceFrom: '—', available: true };
    }
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (prod) {
        var prices = (prod.variants || [])
          .map(function (v) { return parseInt(v.price, 10); })
          .filter(function (x) { return x > 0; });
        if (prices.length) {
          var min = Math.min.apply(null, prices);
          window.IC_PRODUCT_PRICES[key].priceFrom = Math.round(min / 100) + ' lei';
        }
        window.IC_PRODUCT_PRICES[key].available = !!prod.available;
        if (typeof state !== 'undefined' && state.origin === key && typeof renderAll === 'function') {
          try { renderAll(); } catch (e) {}
        }
      })
      .catch(function () {});
  });
})();

/* ============================================================
   Înlocuiește blocul lung de text SEO de sub calculator
   (#ic-calc-seo-block, injectat de ic-improvements-global.js)
   cu o notă scurtă: calculatorul e pentru pasionați.
   ============================================================ */
(function () {
  var MINI =
    '<div style="max-width:640px;margin:28px auto 0;padding:22px 24px;' +
    'background:rgba(255,255,255,.55);border:1px solid rgba(26,22,18,.10);' +
    'border-radius:14px;text-align:center;">' +
    '<div style="font:700 12px/1 Lato,sans-serif;letter-spacing:.18em;' +
    'text-transform:uppercase;color:#C9A96E;margin-bottom:10px;">Făcut pentru pasionați</div>' +
    '<p style="margin:0;font:400 15px/1.6 Lato,sans-serif;color:rgba(26,22,18,.78);">' +
    'Acest calculator e creat pentru pasionații de cafea și în ajutorul lor — îți dă un ' +
    'punct de plecare calibrat pentru fiecare origine și metodă, apoi îl ajustezi după gustul tău.' +
    '</p></div>';

  function trimSeo() {
    var b = document.getElementById('ic-calc-seo-block');
    if (!b) return false;
    b.innerHTML = MINI;
    b.style.background = 'none';
    b.style.border = '0';
    b.style.padding = '0';
    return true;
  }

  if (!trimSeo()) {
    var mo = new MutationObserver(function () { if (trimSeo()) mo.disconnect(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { try { mo.disconnect(); } catch (e) {} trimSeo(); }, 5000);
  }
})();
